import React, {Fragment, useEffect, useState} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../utils/global-contexts/AuthContext";
import {useApp} from "../utils/global-contexts/AppContext";
import {useQueryClient} from "@tanstack/react-query";
import {VscLoading} from "react-icons/vsc";
import useGetWhoAmI from "../utils/custom-hooks/useGetWhoAmI";

type Props = {
    children: React.ReactNode
}

const ProtectedRoute = ({children}: Props) => {
    const {isAuthenticated, setIsAuthenticated} = useAuth();
    const {selectedEstimate, setUserId} = useApp()
    const {pathname} = useLocation()
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(true);

    const {data} = useGetWhoAmI()
    useEffect(() => {
        if (data) {
            setUserId(data.user)
        }
    }, [data]);


    useEffect(() => {
        queryClient.invalidateQueries({queryKey: ['useApiGetEstimateUserfields', selectedEstimate?.id]});
    }, [pathname, selectedEstimate?.id]);

    useEffect(() => {
        const access_token = localStorage.getItem('@access_token');

        if (access_token) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }

        setIsLoading(false);
    }, [setIsAuthenticated]);

    return (
        <>
            {isLoading ? (
                <VscLoading/> // Loading spinner while checking authentication
            ) : isAuthenticated ? (
                <Fragment>{children}</Fragment> // Render children if authenticated
            ) : (
                <Navigate to="/login" replace/> // Redirect to login if not authenticated
            )}
        </>
    );

};

export default ProtectedRoute;
